import { Pencil } from "lucide-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import useLocationMediaList from "../../../containers/FacilityDetailsPage/hooks/useLocationMediaList";
import { useMe } from "../../../hooks/queries";
import { AccountType } from "../../../models/AccountData";
import { FeatureUseLimitCalculator } from "../../../models/featureUseLimits/FeatureUseLimitsCalculator";
import {
  FeatureUseStatus,
  OrgFeatures,
} from "../../../models/featureUseLimits/FeatureUseLimitsData.const";
import { RecentMediaList } from "../../DashboardComponents/RecentMediaList";
import { ModalUploadMedia } from "../../MediaComponents/ModalUploadMedia";

import "./styles.scss";

interface IRecentMediaUploadsSectionProps {
  locationId: string;
}

export const RecentMediaUploadsSection: React.FunctionComponent<
  IRecentMediaUploadsSectionProps
> = ({ locationId }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.recentMediaUploads.${key}`);
  const history = useHistory();

  const { data } = useLocationMediaList(locationId);
  const recentMediaList = data ?? [];
  const { data: me } = useMe();

  const [showUploadModal, setShowUploadModal] = useState(false);

  const canUploadMedia =
    me?.type === AccountType.ADMIN ||
    me?.type === AccountType.LOC_ADMIN ||
    (me?.type === AccountType.ORG_ADMIN &&
      FeatureUseLimitCalculator.getFeatureUseStatus(
        OrgFeatures.USE_LOCAL_POST,
        me.organization?.commonFeatureUseLimit
      ) === FeatureUseStatus.CAN_USE);

  const handleViewMore = () => {
    history.push(`/location/${locationId}/media`);
  };

  return (
    <div className="recent-media-uploads-container">
      <RecentMediaList
        dataList={recentMediaList.slice(0, 5)}
        hideLocationName
      />
      <div className="media-uploads-button-group">
        {recentMediaList.length > 0 && (
          <button className="btn btn-border" onClick={handleViewMore}>
            {t("view_more")}
          </button>
        )}
        {canUploadMedia && (
          <button
            className="btn btn-blue btn-new-media"
            onClick={() => setShowUploadModal(true)}
          >
            <Pencil size={16} color="white" className="pencil-icon" />
            {t("post")}
          </button>
        )}
      </div>
      {showUploadModal && (
        <ModalUploadMedia
          locationId={locationId}
          onClose={() => setShowUploadModal(false)}
        />
      )}
    </div>
  );
};

export default RecentMediaUploadsSection;
